import { render, staticRenderFns } from "./user-passwords.vue?vue&type=template&id=b474f1d4&"
import script from "./user-passwords.vue?vue&type=script&lang=js&"
export * from "./user-passwords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports